import { render, staticRenderFns } from "./WebPagesCurrentBlocks.vue?vue&type=template&id=8b0db01c&"
import script from "./WebPagesCurrentBlocks.vue?vue&type=script&lang=js&"
export * from "./WebPagesCurrentBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports